import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import { getCustomerPeriodicities } from '@hungryroot/rest/api/v2/customers/[id]/periodicities/get';

const timeLimit = 15 * 60 * 1000;

export function useCustomerPeriodicities(
  options?: Pick<UseQueryOptions, 'enabled'>
) {
  return useQuery({
    queryKey: ['Customers', 'periodicities'],
    queryFn: async () => {
      const resp = await getCustomerPeriodicities();

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    ...options,
    retry: false,
    enabled: options?.enabled,
    gcTime: timeLimit,
    staleTime: timeLimit,
  });
}
